import { render, staticRenderFns } from "./AdminCommandGV20.vue?vue&type=template&id=23fc593c&scoped=true&"
import script from "./AdminCommandGV20.vue?vue&type=script&lang=js&"
export * from "./AdminCommandGV20.vue?vue&type=script&lang=js&"
import style0 from "./AdminCommandGV20.vue?vue&type=style&index=0&id=23fc593c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc593c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23fc593c')) {
      api.createRecord('23fc593c', component.options)
    } else {
      api.reload('23fc593c', component.options)
    }
    module.hot.accept("./AdminCommandGV20.vue?vue&type=template&id=23fc593c&scoped=true&", function () {
      api.rerender('23fc593c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/device_command_types/AdminCommandGV20.vue"
export default component.exports